import React, { memo, useCallback } from 'react';

import { cn } from '@lyearn/style';
import { Checkbox, Stack, Typography } from '@lyearn/ui';
import { JiraIssueType } from '@/types/schema';

type ListItemProps = {
  jiraIssue: JiraIssueType;
  selected?: boolean;
  isFirstItem?: boolean;
  onSelect: (jiraIssue: JiraIssueType) => void;
};

function ListItem(props: ListItemProps) {
  const { jiraIssue, selected, onSelect, isFirstItem } = props;

  const _onSelect = useCallback(() => {
    onSelect(jiraIssue);
  }, [jiraIssue, onSelect]);

  const isPreviouslySelected = jiraIssue.isActionItemLinked;

  return (
    <Stack
      alignItems="center"
      className="group rounded-8 px-8 hover:bg-s-info-light"
      role="button"
      onClick={isPreviouslySelected ? undefined : _onSelect}>
      <Stack
        alignItems="center"
        className={cn('w-full py-16 px-8', {
          'border-t border-border': !isFirstItem,
        })}
        justifyContent="between">
        <Stack className="truncate pe-20" direction="col">
          <Typography className="truncate" color="text-text-paragraph" variant="body-short-01">
            {jiraIssue.summary}
          </Typography>
          <Typography className="mt-4" color="text-text-secondary" variant="body-short-02">
            {jiraIssue.key}
          </Typography>
        </Stack>
        <Checkbox checked={selected || isPreviouslySelected} disabled={isPreviouslySelected} />
      </Stack>
    </Stack>
  );
}

export default memo(ListItem);
